module.exports = __webpack_public_path__ + "assets/img/customer-service.6a0656b1.png";